import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CameraSettingComponent } from '@pages/camera-settings/camera-setting.component';
import { LoginComponent } from '@pages/login/login.component';
import { CameraRealtimeMapComponent } from './pages/camera-realtime-map/camera-realtime-map.component';
import { ForgotPasswordComponent } from '@pages/forgot-password/forgot-password.component';
import { ReportComponent } from '@pages/reports/report/report.component';
import { WebrtcfeedsComponent } from '@pages/webrtcfeeds/webrtcfeeds.component';

const routes: Routes = [
    {
        path: 'CameraSettings.aspx',
        component: CameraSettingComponent
    },
    {
        path: 'DeviceLiveLocation.aspx',
        component: CameraRealtimeMapComponent
    },
    {
        path: 'LoginAngular.aspx',
        component: LoginComponent
    },
    {
        path: 'ForgotPassword.aspx',
        component: ForgotPasswordComponent
    },
    {
        path: 'AngularReports.aspx',
        component: ReportComponent
    },
    {
        path: 'Webrtcfeeds.aspx',
        component: WebrtcfeedsComponent
    },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
